<template>
  <div id="reservationDetail">
    <el-row :gutter="20">
      <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="6">
          <span class="fs-14 secondary-text">Type : </span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text font-weight-900" v-if="!reservation.delayed && !reservation.intent">{{ $t('reservation.type.onAvailableProduct') }}</span>
          <span class="fs-14 secondary-text font-weight-900" v-if="reservation.delayed">{{ $t('reservation.type.onProductInSupply') }}</span>
          <span class="fs-14 secondary-text font-weight-900" v-if="reservation.intent">{{ $t('reservation.type.onPurchaseIntent') }}</span>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-if="reservation.createdBy != null">
      <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="6">
          <span class="fs-14 secondary-text">{{$t('common.createdByField')}}</span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text" >{{reservation.createdBy.firstName}} {{reservation.createdBy.lastName}} {{ $t('common.dateAt') }} {{_moment(reservation.created_at)}}</span>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-if="reservation.updatedBy != null">
      <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="6">
          <span class="fs-14 secondary-text">{{$t('common.updatedByField')}}</span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text" >{{reservation.updatedBy.firstName}} {{reservation.updatedBy.lastName}} {{ $t('common.dateAt') }} {{_moment(reservation.updated_at)}}</span>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="6">
          <span class="fs-14 secondary-text">{{$t('reservation.dateField')}}</span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text" v-if="reservation.date != null">{{_moment(reservation.date)}}</span>
          <span class="fs-14 secondary-text" v-else>{{ $t('common.notAvailable') }}</span>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="6">
          <span class="fs-14 secondary-text">{{$t('reservation.ageField')}}</span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div class="fs-14 secondary-text" v-if="!reservation.delayed && !reservation.intent">
            <span v-if="reservation.nb_days==0">{{$t('reservation.today')}}</span><span v-else>{{reservation.nb_days}} {{ $t('reservation.days') }}</span>
            <status-indicator class="ml-10" :negative="isNegative(reservation.nb_days)" :intermediary="isIntermediary(reservation.nb_days)" :positive="isPositive(reservation.nb_days)" pulse/>
          </div>
          <div class="fs-14 secondary-text" v-else>
            <span>{{ $t('common.notAvailable') }}</span>
          </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="6">
          <span class="fs-14 secondary-text">{{$t('reservation.limitDate')}}</span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span v-if="reservation.limit_date != null" class="fs-14 secondary-text">{{_moment(reservation.limit_date)}}</span>
          <span v-else class="fs-14 secondary-text"> -- </span>
      </el-col>
    </el-row>
    <!-- <el-row :gutter="20">
      <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="6">
          <span class="fs-14 secondary-text">{{$t('reservation.limitDateField')}}</span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div class="fs-14 secondary-text" v-if="!reservation.delayed && !reservation.intent">
            <span>{{_moment(selectedReservationlimitDate)}}</span>
          </div>
          <span class="fs-14 secondary-text" v-else> {{ $t('common.notAvailable') }}</span>
      </el-col>
    </el-row> -->
    <el-row :gutter="20">
      <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="6">
          <span class="fs-14 secondary-text">{{$t('reservation.customerField')}}</span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text">
            <PortausLink :id="reservation.customer.id" path="/customers/" :label="reservation.customer.usual_name || reservation.customer.name"></PortausLink>
          </span>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="6">
          <span class="fs-14 secondary-text">{{$t('reservation.contactField')}}</span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span v-if="followUpContactNotEmpty" class="fs-14 secondary-text">{{contacts}}</span>
        <span v-else class="fs-14 secondary-text">{{ $t('common.notAvailable') }}</span>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="6">
          <span class="fs-14 secondary-text">{{$t('reservation.repField')}}</span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span v-if="reservation.sales_rep!=null" class="fs-14 secondary-text">{{reservation.sales_rep.first_name}} {{reservation.sales_rep.last_name}}</span>
          <span v-else class="fs-14 secondary-text">{{ $t('common.notAvailable') }}</span>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="6">
          <span class="fs-14 secondary-text">{{ $t('common.statusField')}}</span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <span v-if="isActive(reservation)" >
          <el-tag v-if="!reservation.delayed && !reservation.intent" type="success" size="small" style="margin-top:5px;">{{$t("reservations.statuses.active")}}</el-tag>
          <el-tag v-else type="info" size="small" style="margin-top:5px;">{{$t("reservations.statuses.active")}}</el-tag>
        </span>
        <span v-else>
          <el-tag v-if="reservation.expired" type="danger" size="small" style="margin-top:5px;">{{$t("reservations.statuses.expired")}}</el-tag>
          <el-tag v-else type="danger" size="small" style="margin-top:5px;">{{$t("reservations.statuses.completed")}}</el-tag>
        </span>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import PortausLink from '@/components/portaus-link'

export default {
  name: 'reservation-infos',
	props: {
    reservation: {
      type: Object,
      default : null,
    }


	},
  data() {
    return {

    };
  },components: {
    PortausLink,
  },

	methods: {

    _moment(datetime, format='LL'){
      return moment(datetime).format(format);
    }
	},
	computed: {
    contacts () {
      let contacts = [];
      _.forEach(_.get(this.reservation, 'follow_up_contacts'), (c) => {
        contacts.push(`${c.first_name} ${c.last_name}`);
      })
      return _.join(contacts, ', ');
    },
    followUpContactNotEmpty () {
      return _.size(_.get(this.reservation, 'follow_up_contacts')) > 0;
    },
      ...mapGetters('reservations',['isNegative','isPositive','isIntermediary','isActive', 'selectedReservationlimitDate', 'customerName']),

	}
}
</script>
<style lang="scss" scoped>
</style>
